export enum ConversationNodeApiErrorTypes {
  LoadTopicalFlowError,
}

export class ConversationNodeApiError {
  constructor(public type: ConversationNodeApiErrorTypes, public error: Error) {}
}
